/* eslint-disable react/jsx-one-expression-per-line */
import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import H2 from '@base/H2/H2';
import P1 from '@base/P1/P1';
import MenusNav from '@base/MenusNav/MenusNav';
import { menus } from '@utils/constants';
import { Spacings } from '@styles/index';
import Layout from '@layout/index';
import LeftContainer from '@cont/CompanyDetails/LeftContainer';
import RightContainer from '@cont/CompanyDetails/RightContainer';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';

const LegalNoticesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: span 24;
`;

const LegalNoticesContainer = styled.div``;

const H2Container = styled.div``;

const StyledOrderedList = styled.ol`
  padding-left: ${Spacings.SPACING_4B};
`;

const TakedownPolicy = () => {
  const router = useRouter();
  const { pathname } = router;

  return (
    <>
      <LeftContainer>
        <MenusNav data={menus} currentHref={pathname} />
      </LeftContainer>

      <RightContainer>
        <LegalNoticesWrapper>
          <LegalNoticesContainer>
            <H2Container>
              <H2 as="h1">Takedown Policy</H2>
              <P1>Copyright, Trademarks, and other Intellectual Properties</P1>
            </H2Container>
            <br />

            <P1>
              All rights in the User-generated Content (including Content
              Provider Content) made available on the Platform are owned by the
              Users, where Unacademy is a limited license holder to publish the
              same on Platform. Please read the Terms and Conditions to know the
              exact nature of license and rights Users grant to Unacademy.
              User-generated Content is subject to the Platform Terms (
              <i>as defined in the Terms and Conditions</i>), and hence, kindly
              ensure that you use the User-generated Content only within the
              parameters as provided in the Platform Terms. You are prohibited
              from using the User-generated Content as your own without the
              prior permission of the content creator and Unacademy.
            </P1>
            <br />
            <P1>
              Unacademy Content (<i>as defined in the Terms and Conditions</i>)
              on the Unacademy Platform including but not limited to, images,
              graphics, process, images, software, are owned by or licensed to
              Unacademy and subject to Copyright and trademark protections and
              you are prohibited from using the same as your own, without the
              prior permission of Unacademy. For clarity, Unacademy Content does
              not include User-generated Content.
            </P1>
            <br />
            <P1>
              We have implemented the following procedures for receiving written
              notification of claimed infringements on the User-generated
              Content uploaded on the Platform. If you believe that your
              intellectual property rights or of any person you are aware of,
              have been used in a way that gives rise to concerns of
              infringement, you may either report such User-generated Content by
              using the report button provided within the Platform or write to
              us at{' '}
              <a href="mailto:legal@unacademy.com">legal@unacademy.com </a>
              with complete details as required under below.
            </P1>
            <br />
            <P1>
              Capitalized terms used but not defined in this Policy can be found
              in our Platform Terms.
            </P1>
            <br />

            <StyledOrderedList type="A">
              <li>
                <P1>
                  <b>COPYRIGHT COMPLAINTS AND TAKEDOWN POLICY:</b>
                </P1>
                <br />
                <ol>
                  <li>
                    <P1>
                      <b>Copyrights Complaints:</b> All complaints/ notices of
                      alleged copyright infringements or violations received by
                      Unacademy shall be processed, investigated and appropriate
                      actions will be taken in the following manner:
                    </P1>
                    <br />
                    <P1>
                      For all User-generated Content published in respect of
                      Services offered under International Goals, complaints/
                      notices of alleged copyright infringements or violations
                      received by Unacademy shall be dealt with in accordance
                      with the Digital Millennium Copyright Act (see 17 U.S.C. §
                      512(c)(3)) (“DMCA”) and other applicable intellectual
                      property laws. If you, in good faith, believe that your
                      work or that of a person you know, has been copied in a
                      way that constitutes copyright infringement or violation,
                      a notification of claimed copyright infringement or
                      violation should be emailed to Unacademy’s designated
                      copyright agent at{' '}
                      <a href="mailto:legal@unacademy.com">
                        legal@unacademy.com{' '}
                      </a>
                      (Subject line: “DMCA Takedown Request”) which contains the
                      information stated hereinbelow. You may also send the said
                      information by mail at: Unacademy Inc., Attention: DMCA
                      Takedown Request, Vistra (Delaware) Ltd, 3500, South
                      Dupont, HWY, Dover, Kent, DE 19901, Delaware, USA.
                    </P1>
                    <br />
                    <P1>
                      For all User-generated Content published in respect of all
                      Services (excluding those under International Goals,
                      complaints/ notices of alleged copyright infringements or
                      violations received by Unacademy shall be dealt with in
                      accordance with the Indian Copyright Act, 1957 (as amended
                      from time to time). If you, in good faith, believe that
                      your work or that of a person you know, has been copied in
                      a way that constitutes copyright infringement or
                      violation, a notification of claimed copyright
                      infringement or violation should be emailed to Unacademy
                      at{' '}
                      <a href="mailto:legal@unacademy.com">
                        legal@unacademy.com{' '}
                      </a>{' '}
                      (Subject line: “Copyright: Takedown Request - India”)
                      which contains the information stated hereinbelow. You may
                      also send the said information by mail at: Sorting Hat
                      Technologies Private Limited, Maruti Infotech Centre, 3rd
                      Floor, A-Block, Domlur, Koramangala Inner Ring Road,
                      Bangalore- 560 071, Karnataka, India.
                    </P1>
                    <br />
                    <P1>
                      Please note that by claiming copyright infringement you
                      are initiating a legal process, kindly be sure to consider
                      whether fair use, fair dealing, or a similar exception to
                      copyright apply before you report.
                    </P1>
                    <br />
                    <P1>
                      To be effective, the notification you send to us must be
                      in writing and contain the following information:
                    </P1>
                    <ol type="i">
                      <li>
                        <P1>
                          an electronic or physical signature of you or the
                          person authorized to act on behalf of the owner of the
                          copyright or other intellectual property interest;
                        </P1>
                      </li>
                      <li>
                        <P1>
                          a description of the copyrighted work or other
                          intellectual property that you claim has been
                          infringed;
                        </P1>
                      </li>
                      <li>
                        <P1>
                          a description of where the material that you claim is
                          infringing is located on the Platform, with enough
                          detail that we may find it on the Platform;
                        </P1>
                      </li>
                      <li>
                        <P1>
                          Your address, telephone number, and email address;
                        </P1>
                      </li>
                      <li>
                        <P1>
                          a statement by you that you have a good faith belief
                          that the disputed use is not authorized by the
                          copyright or intellectual property owner, its agent,
                          or the law;
                        </P1>
                      </li>
                      <li>
                        <P1>
                          a statement by you, made under penalty of perjury,
                          that the above information in your notice is accurate
                          and that you are the copyright or intellectual
                          property owner or authorized to act on the copyright
                          or intellectual property owner’s behalf.
                        </P1>
                      </li>
                    </ol>
                    <br />
                    <P1>
                      Please note that we may send a copy of any infringement
                      claim received to the User who posted the content that was
                      reported by you as infringing.
                    </P1>
                    <br />
                    <P1>
                      If you submit a notice of infringement that knowingly
                      materially misrepresents that any content, information, or
                      communication on the Platform is infringing upon a
                      copyright, you may be held liable for damages and
                      attorneys’/lawyers’ fees.
                    </P1>
                  </li>
                  <br />
                  <li>
                    <P1>
                      <b>Counter-Notice:</b> If you believe that any
                      User-generated Content that was removed (or to which
                      access was disabled) is not infringing, or that you have
                      the authorization from the copyright owner, the copyright
                      owner’s agent, or pursuant to the law, to upload and use
                      the content in such User-generated Content, you may send a
                      written counter-notice containing the following
                      information to Unacademy’s designated agent using any of
                      the methods mentioned under ‘Copyrights Complaint’ section
                      above:
                    </P1>
                    <ol type="i">
                      <li>
                        <P1>Your physical or electronic signature;</P1>
                      </li>
                      <li>
                        <P1>
                          identification of the content that has been removed or
                          to which access has been disabled and the location at
                          which the content appeared before it was removed or
                          disabled;
                        </P1>
                      </li>
                      <li>
                        <P1>
                          a statement that you have a good faith belief that the
                          content was removed or disabled as a result of mistake
                          or a misidentification of the content; and
                        </P1>
                      </li>
                      <li>
                        <P1>
                          Your name, address, telephone number, and email
                          address, a statement that you consent to the
                          applicable jurisdiction of the courts as per the Terms
                          and Conditions, and a statement that you will accept
                          service of process from the person who provided
                          notification of the alleged infringement.
                        </P1>
                      </li>
                    </ol>
                    <br />
                    <P1>
                      If a counter-notice is received by Unacademy, then
                      Unacademy will send a copy of the counter-notice to the
                      original complaining party informing that person, that it
                      may replace the removed content or cease disabling it in
                      10 (ten) business days. Unless the copyright owner files
                      an action seeking a court order against the content
                      provider, member or user, the removed content may be
                      replaced, or access to it restored, in 10 (ten) to 14
                      (fourteen) business days or more after receipt of the
                      counter-notice, at our sole discretion.
                    </P1>
                  </li>
                </ol>
              </li>
              <br />
              <li>
                <P1>
                  <b>TRADEMARKS AND OTHER INTELLECTUAL PROPERTY RIGHTS:</b>
                </P1>
                <br />
                <P1>
                  The trademarks, service marks, logos displayed on the
                  Unacademy Platform are owned by Unacademy{' '}
                  <b>(“Unacademy Marks”)</b> or licensed by Unacademy to use on
                  the Unacademy Platform. If you haven’t received our
                  permission, do not use the Unacademy Marks as your own or in
                  any manner that implies sponsorship or endorsement or any
                  relation to Unacademy.
                </P1>
                <br />
                <P1>
                  A product or service branded with the Unacademy name or logo
                  is a reflection of Unacademy. Unless you are one of our
                  licensees, we don’t allow others to make, sell, or give away
                  anything with our name or logo on it.
                </P1>
                <br />
                <P1>
                  Further, if you believe that your intellectual property rights
                  (other than copyrights) or that of any person you know have
                  been used in a way that gives rise to concerns of
                  infringement, then kindly write to us at{' '}
                  <a href="mailto:legal@unacademy.com">legal@unacademy.com </a>{' '}
                  with a description of the trademark or intellectual property
                  that you claim has been infringed, a description of where the
                  material that you claim is infringing is located on the
                  Platform, with enough detail that we may find it on the
                  Platform, and your address, telephone number, and email
                  address.
                </P1>
              </li>
              <br />
              <li>
                <P1>
                  <b>REPEAT INFRINGER POLICY:</b>
                </P1>
                <br />
                <P1>
                  Unacademy has adopted a policy of terminating users who are
                  deemed to be repeat infringers, in appropriate circumstances
                  and at Unacademy’s sole discretion. Unacademy may also at its
                  sole discretion, limit access to the Platform and/or terminate
                  the accounts of any users who infringes any intellectual
                  property rights of others, whether or not there is any repeat
                  infringement. Further, we reserve the right to remove access
                  to any content that we know, or have reason to know, violates
                  the intellectual property rights of Unacademy or other Users.
                </P1>
              </li>
              <br />
              <li>
                <P1>
                  <b>DESIGNATED COPYRIGHT AGENT:</b>
                </P1>
                <br />
                <P1>Legal Department, Unacademy</P1>
                <P1>
                  Email ID:
                  <a href="mailto:legal@unacademy.com"> legal@unacademy.com</a>
                </P1>
              </li>
            </StyledOrderedList>
            <br />
            <P1>
              <i>Takedown Policy – Version 1.0</i>
            </P1>
            <P1>
              <i>Last Updated on 17th March 2022</i>
            </P1>
          </LegalNoticesContainer>
        </LegalNoticesWrapper>
      </RightContainer>
    </>
  );
};

TakedownPolicy.pageInfo = {
  name: 'Takedown Policy',
  isMWebSupported: true,
  layoutOptions: {
    hideGoalSelector: true,
    disableDarkMode: true
  }
};

export default TakedownPolicy;
TakedownPolicy.Layout = Layout;
TakedownPolicy.Wrapper = PageReduxProvider;
